import React from "react";
import PublicNavbar from "../../components/PublicNavbar";
import Footer from "../../components/Footer";

export default function LegalTerms() {
  return (
    <div className="min-h-screen bg-white">
      <PublicNavbar />
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-16">
        <div className="overline">Informations légales</div>
        <h1 className="font-heading text-3xl sm:text-4xl font-medium tracking-tight text-slate-900 mt-2">
          Conditions générales d'utilisation et de vente
        </h1>
        <div className="text-xs text-slate-500 mt-1">Dernière mise à jour : 13 juin 2026</div>

        <div className="prose prose-slate max-w-none mt-10 text-[15px] leading-relaxed space-y-8">
          <Section title="1. Objet">
            <p>
              Les présentes conditions générales encadrent l'utilisation de la plateforme
              <strong> Junago</strong>, logiciel de gestion de flotte en mode SaaS destiné aux
              professionnels de la location de véhicules, éditée par Junago SAS.
            </p>
          </Section>

          <Section title="2. Abonnement et essai gratuit">
            <ul className="list-disc pl-5 space-y-1">
              <li>Toute souscription débute par un <strong>essai gratuit de 30 jours</strong>, sans carte bancaire, donnant accès à l'intégralité de la plateforme.</li>
              <li>À l'issue de l'essai, l'accès se poursuit via un abonnement mensuel ou annuel selon la formule choisie.</li>
              <li>L'abonnement est résiliable à tout moment depuis l'espace client, sans frais ni préavis.</li>
            </ul>
          </Section>

          <Section title="3. Services fournis">
            <p>
              L'abonnement inclut notamment : le calendrier de pilotage, la gestion des réservations et
              devis, les contrats et la signature électronique, les états des lieux, les encaissements
              via Stripe, la facturation, les emails automatiques, le site internet de réservation
              généré et hébergé par Junago, ainsi que l'assistant Junago Copilot.
            </p>
          </Section>

          <Section title="4. Responsabilités">
            <p>
              Junago fournit un outil logiciel : le loueur demeure seul responsable de son activité de
              location, de ses contrats, de ses obligations légales et fiscales, et des informations
              qu'il publie. Junago s'engage à assurer la disponibilité et la sécurité de la plateforme
              dans les conditions d'un service professionnel.
            </p>
          </Section>

          <Section title="5. Paiements">
            <p>
              Les encaissements clients sont opérés par <strong>Stripe</strong>, prestataire de
              paiement agréé. Junago ne stocke aucune donnée bancaire. Les fonds encaissés sont versés
              directement sur le compte du loueur selon les conditions de Stripe.
            </p>
          </Section>

          <Section title="6. Données">
            <p>
              Les données saisies dans la plateforme restent la propriété du loueur. Elles sont
              exportables à tout moment (CSV) et supprimées sur demande à la clôture du compte,
              conformément à notre <a className="text-violet-600 underline" href="/legal/privacy">politique de confidentialité</a>.
            </p>
          </Section>

          <Section title="7. Droit applicable">
            <p>
              Les présentes conditions sont soumises au droit français. Tout litige relève, à défaut
              d'accord amiable, des tribunaux compétents de Paris.
            </p>
          </Section>

          <Section title="8. Contact">
            <p>
              Pour toute question :{" "}
              <a className="text-violet-600 underline" href="mailto:contact@junago.fr">contact@junago.fr</a>.
            </p>
          </Section>
        </div>
      </div>
      <Footer />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-heading text-lg font-medium text-slate-900 mb-2">{title}</h2>
      <div className="text-slate-600 space-y-3">{children}</div>
    </section>
  );
}
